import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import AuthCallback from './components/AuthCallback';
import Dashboard from './pages/Dashboard';
import HtmlPreview from './pages/HtmlPreview';
import AddressMapPage from './pages/AddressMapPage';
import IconPreview from './pages/IconPreview';
import Login from './pages/Login';
import GiftcardManagement from './pages/GiftcardManagement';
import CustomerForm from './pages/CustomerForm';
import ActivationSuccess from './pages/ActivationSuccess';
import PermissionDenied from './pages/PermissionDenied';
import MemberList from './pages/MemberList';
import MemberSignup from './pages/MemberSignup';
import MemberForm from './pages/MemberForm';
import MemberDetail from './pages/MemberDetail';
import MemberEdit from './pages/MemberEdit';
import ModuleSetup from './pages/ModuleSetup';
import MemberReport from './pages/MemberReport';

// Create MUI theme
const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      '"Microsoft YaHei"',
      '"PingFang SC"',
      '"Hiragino Sans GB"',
      '"Noto Sans CJK SC"',
      'sans-serif',
    ].join(','),
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Router>
          <AuthProvider>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/customer-form" element={<CustomerForm />} />
            <Route path="/member-signup" element={<MemberSignup />} />
            <Route path="/member-form" element={<MemberForm />} />
            <Route path="/activation-success" element={<ActivationSuccess />} />
            <Route path="/permission-denied" element={<PermissionDenied />} />
            
            {/* Protected routes */}
            <Route path="/*" element={
              <ProtectedRoute>
                <Layout>
                  <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/html-preview" element={<HtmlPreview />} />
                    <Route path="/address-map" element={<AddressMapPage />} />
                    <Route path="/icon-preview" element={<IconPreview />} />
                    <Route path="/giftcards" element={<GiftcardManagement />} />
                    <Route path="/members" element={<MemberList />} />
                    <Route path="/member-detail" element={<MemberDetail />} />
                    <Route path="/member-edit" element={<MemberEdit />} />
                    <Route path="/member-report" element={<MemberReport />} />
                    <Route path="/membership-module-setup" element={<ModuleSetup />} />
                  </Routes>
                </Layout>
              </ProtectedRoute>
            } />
          </Routes>
        </AuthProvider>
      </Router>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;
